export default {
    DNI: 1,
    NIE: 2,
    MENOR: 3,
    PASAPORTE: 4,
    CIF: 5
};